import { render, staticRenderFns } from "./ComGoods2.vue?vue&type=template&id=520e28b3&scoped=true&"
import script from "./ComGoods2.vue?vue&type=script&lang=js&"
export * from "./ComGoods2.vue?vue&type=script&lang=js&"
import style0 from "./ComGoods2.vue?vue&type=style&index=0&id=520e28b3&prod&lang=css&"
import style1 from "./ComGoods2.vue?vue&type=style&index=1&id=520e28b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e28b3",
  null
  
)

export default component.exports